module.exports = __webpack_public_path__ + "img/cms-for-tablets-ui.fe9700ce.png";